import { IDeleteEmpreendimentoUseCase } from "../../../presentation/useCases/delete/delete_empreendimento_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * DeleteEmpreendimentoUseCase
 */

export class DeleteEmpreendimentoUseCase implements IDeleteEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async deleteEmpreendimento(idEmpreendimento: number): Promise<void> {
    await this.repository.deleteEmpreendimento(idEmpreendimento)

  }
}
